"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
const AgronomicInsightsPanel_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/AgronomicInsights/AgronomicInsightsPanel.vue"));
const Teaser_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Teaser.vue"));
const MetricRankTag_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/MetricRankTag.vue"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
const floating_vue_1 = require("floating-vue");
const OptimalRange_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/OptimalRange.vue"));
let MetricChartItem = class MetricChartItem extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.colorController = new ColorLibController_1.default();
        this.isInsightDeployed = false;
        this.eventTracker = new EventTracker_1.default();
    }
    updateFieldActiveKey(f) {
        this.$emit('updateFieldActiveKey', f);
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get metricName() {
        if ('baseMetric' in this.metric)
            return `${this.metric.baseMetric.name}`;
        else
            return this.metric.name;
    }
    get metricSurname() {
        if ('baseMetric' in this.metric) {
            if ('test_name' in this.metric.baseMetric)
                return `${this.metric.baseMetric.test_name}`;
        }
        else {
            if ('test_name' in this.metric)
                return `${this.metric.test_name}`;
        }
        return '';
    }
    get metricScore() {
        if ('baseMetric' in this.metric) {
            if ('scoreBC' in this.metric.baseMetric)
                return this.metric.baseMetric.scoreBC.value;
            else
                return this.metric.baseMetric.score;
        }
        else {
            if ('scoreBC' in this.metric)
                return this.metric.scoreBC.value;
            else
                return this.metric.score;
        }
    }
    get metricUnit() {
        if ('baseMetric' in this.metric) {
            return this.metric.baseMetric.unit;
        }
        else {
            return this.metric.unit;
        }
    }
    get hasChart() {
        if ('category' in this.metric)
            return true;
        return false;
    }
    get hasAgInsights() {
        if ('insights' in this.metric) {
            if (this.metric.insights.show_insight)
                return true;
        }
        return false;
    }
    get colorClass() {
        let rank = '';
        let scale = '';
        if ('scoreBC' in this.metric && 'scale' in this.metric) {
            rank = this.colorController.getRankShortNameFromScore(this.metric.scoreBC.value);
            scale = (this.metric.scale === 'hlt') ? 'alt_' : '';
        }
        return 'bmfw-background-color-bmk_rank_' + scale + rank;
    }
    deployInsight() {
        this.isInsightDeployed = true;
        this.eventTrackerListener();
    }
    eventTrackerListener() {
        this.eventTracker.trackEvent('deployInsight', {
            metric: this.metricName
        });
    }
    dismissInsight() {
        this.isInsightDeployed = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MetricChartItem.prototype, "metric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MetricChartItem.prototype, "metricAgInsights", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MetricChartItem.prototype, "mainProjectDelivery", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MetricChartItem.prototype, "isActive", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MetricChartItem.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MetricChartItem.prototype, "fieldActiveKey", void 0);
MetricChartItem = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            AgronomicInsightsPanel: AgronomicInsightsPanel_vue_1.default,
            Teaser: Teaser_vue_1.default,
            MetricRankTag: MetricRankTag_vue_1.default,
            OptimalRange: OptimalRange_vue_1.default,
            ArrowUp: lucide_vue_next_1.ArrowUp,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            AlertTriangle: lucide_vue_next_1.AlertTriangle,
            Dropdown: floating_vue_1.Dropdown
        },
    })
], MetricChartItem);
exports.default = MetricChartItem;
